<template>
    <span>
        <a v-if="descriptionIsValidURL()" :href="description" target="_blank">{{description}}</a>
        <span v-else>{{description}}</span>
    </span>
</template>
<script>
  export default {
    name: 'descriptionOrLink',
    props: {
      description: {
        type: String,
        required: true,
      },
    },
    methods: {
      descriptionIsValidURL() {
        try {
          new URL(this.description);
          return true;
        } catch (_) {
          return false;
        }
      }
    }
  };
</script>
<style></style>
